<template>
  <LoginCard
    data-test-id="UserLogin__EmailEntry"
  >
    <h1
      :class="$style.header"
      data-test-id="UserLogin__EmailEntry__header"
    >
      User Login
    </h1>
    <form
      :action="submit"
      autocomplete="on"
      method="post"
    >
      <LoginTextField
        autoFocus
        label="Email"
        name="email"
        placeholder="User Email Address"
        required
        :submitOnEnter="submit"
        type="email"
        vvName="email"
        v-model="form.email"
      />
      <Checkbox
        :class="$style.rememberEmail"
        label="Remember me"
        v-model="form.shouldRememberEmail"
      />
      <LoginActionButton
        :action="submit"
        data-automation="loginButton"
        :isLoading="isLoading"
        type="submit"
      >
        Continue
      </LoginActionButton>
    </form>
  </LoginCard>
</template>
<script>
import { LoginConsts } from 'client/util/Constants';
import Checkbox from 'client/components/forms/Checkbox.vue';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginCard from 'client/components/LoginCard.vue';
import LoginTextField from 'client/components/LoginTextField.vue';
import api from 'client/api';

const {
  clientType,
  responseMessages,
} = LoginConsts;
const { user } = clientType;
const userApi = api[user];
const {
  passwordRequired,
} = responseMessages;

export default {
  name: 'EmailEntry',

  userApi,

  components: {
    Checkbox,
    LoginActionButton,
    LoginTextField,
    LoginCard,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    getCredentials() {
      const { email } = this.form;

      return { email };
    },

    submit() {
      this.$emit('resetErrorMessage');

      this.isLoading = true;

      return this.$options.userApi.login(this.getCredentials())
        .then(response => this.$emit('success', response))
        .catch(() => this.$emit('error', { response: { data: { message: passwordRequired } } }))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style module>
@import '../../css/login-components.css';

.container {
  padding: 1rem;
}

.rememberEmail {
  display: flex;
  font-size: 0.875rem;
  margin-top: -0.75rem; /** override .loginFieldset margin from input.css */
  text-align: left;
}
</style>
